import { Fragment, ReactNode } from 'react';

import {
  CrudTable,
  CrudTableProps,
  PageHeader,
  PageHeaderProps,
  QueryFilters,
  QueryFiltersProps,
} from 'components';

type Props = {
  header?: PageHeaderProps & { hide?: boolean };
  filters?: QueryFiltersProps;
  afterFiltersContent?: ReactNode;
  table?: CrudTableProps;
  children?: ReactNode | ReactNode[];
};

export const CrudPage: React.FC<Props> = ({
  header,
  filters,
  afterFiltersContent,
  table,
  children,
}) => (
  <Fragment>
    {!!header && !header.hide && <PageHeader {...header} />}
    <div className="tw-flex tw-items-center tw-justify-end">
      <div className="tw-flex-1">
        {filters && <QueryFilters {...filters} />}
      </div>
      {afterFiltersContent && (
        <div className="tw-ml-4">{afterFiltersContent}</div>
      )}
    </div>
    {table && <CrudTable {...table} />}
    {children}
  </Fragment>
);
